module.exports = "#version 100\r\nprecision highp float;\r\n\r\nuniform float u_targetHeight;\r\n\r\nattribute vec3 a_position;\r\n\r\nvarying vec2 blurTextureCoords[11];\r\n\r\nvoid main() {\r\n    gl_Position = vec4(a_position, 1.0);\r\n\r\n    vec2 centerTexCoords = a_position.xy * 0.5 + 0.5;\r\n\r\n    float pixelSize = 1.0 / u_targetHeight;\r\n\r\n    for(int i = -5; i <= 5; i++){\r\n      blurTextureCoords[i + 5] = centerTexCoords + vec2(0.0, pixelSize * float(i));\r\n    }\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/verticalBlurRTT.vert.glsl
// module id = 11
// module chunks = 0